import { useState, useEffect } from "react"
import { navigate } from "vike/client/router"
import Button from "aldoo-ra/Button"
import PlatformAuth from "aldoo-ra/PlatformAuth"
import Value from "aldoo-ra/Value"
import config from "aldoo-ra/Config"
import PubSub from "pubsub-js"
import { UserCircleIcon } from "@heroicons/react/24/outline"

function Navbar() {
  const [auth] = PlatformAuth.useAuth()
  const [profile] = Value("user-profile")
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const onSignin = () => PubSub.publish("signin", { redirect: "/account" })

  const appName = config?.APP_NAME || "Aldoo Status"
  const initial = (profile?.name || auth?.email || "U")[0].toUpperCase()

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b border-bordered backdrop-blur-md transition-all duration-300 ${
        scrolled ? "bg-paper/90 shadow-sm" : "bg-paper/70"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate("/") }}
          className="text-text font-bold text-xl hover:text-link transition-colors"
        >
          {appName}
        </a>

        <div className="flex items-center gap-3">
          {auth && (
            <>
              <Button
                variant="secondary"
                onClick={() => navigate("/projects")}
              >
                Projects
              </Button>
              <Button
                variant="secondary"
                onClick={() => navigate("/notifications")}
              >
                Notifications
              </Button>
            </>
          )}

          {!auth && (
            <Button variant="primary" onClick={onSignin}>
              Sign in
            </Button>
          )}

          {auth && (
            <button
              onClick={() => navigate("/account")}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-link/30 hover:border-link bg-transparent overflow-hidden transition-colors shrink-0"
              title={profile?.name || auth?.email || "Account"}
            >
              {profile?.avatar ? (
                <img src={profile.avatar} alt="" className="w-full h-full object-cover" />
              ) : (
                <span className="text-sm font-semibold text-primary">{initial}</span>
              )}
            </button>
          )}

          {!auth && (
            <button
              onClick={onSignin}
              className="w-8 h-8 flex items-center justify-center group hover:text-link bg-transparent rounded-full overflow-hidden transition-colors shrink-0"
              title="Sign in"
            >
              <UserCircleIcon className="w-8 h-8 text-text group-hover:text-link transition-colors" />
            </button>
          )}
        </div>
      </div>
    </header>
  )
}

export const AldooComponent = {
  id: "Navbar",
  component: Navbar,
  description: "Top navbar: app name on left, Sign in (anon) or Projects + avatar (auth) on right.",
  input: {},
}

export default Navbar
